export const CONTENT_TYPE_HEADER = 'Content-Type'
export const JSON = 'application/json'
